import {TimeQueueItem} from "./TimeQueueItem";

export enum ESendStatus {
  Pending,
  Sending
}

export interface ISendQueueEntry {
  data: TimeQueueItem;
  status: ESendStatus;
}